// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_QzU","cls2":"ReportList-cls2_n2G ReportList-cls1_QzU"};